import React from "react";
import { FaChevronRight } from "react-icons/fa6";
import scoreTable from "../assets/score_table.png";
import { useLanguage } from "../context/LanguageContext";

/**
 * Popup for the informations about the point
 */
const InfoPopup = ({ isOpen, onClose }) => {
  const { t, language } = useLanguage();
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
      {/*Container*/}
      <div className="bg-white w-[514px] rounded-lg shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-200 flex flex-col">
        
        {/*Yellow Header*/}
        <div className="bg-yellow400 w-[514px] h-[48px] px-8 text-white text-center font-bold text-[19px] uppercase leading-tight flex items-center justify-center">
          {t("pointsBreakdown", "POINTS BREAKDOWN")}
        </div>

        {/* White Body*/}
        <div className="bg-white w-full p-6 flex flex-col items-center">
          {/* Score Table Image */}
          <img 
            src={scoreTable} 
            alt="Points Breakdown" 
            className="w-full h-auto mb-6 rounded-sm"
          />

          {/*DONE Button */}
          <div className="flex flex-row justify-end w-full">
            <button
              onClick={onClose}
              className="btn-results-sm transition-all shadow-md active:scale-95 relative"
            >
              <span className="btn-text-pos-right-sm">{t("button.done", "DONE")}</span>
              <FaChevronRight className="arrow-pos-right-sm" style={{strokeWidth: '2.5'}} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoPopup;
